import { IInstallServices, IServices, IUpdateService } from '../_types/interfaces';

const getServices = async (): Promise<IServices> => {
    return new Promise<IServices>(resolve => setTimeout(() => resolve({
        services: [
            {name: 'Reader', version: '1.0.0.0', download: 'today'},
            {name: 'Web', version: '1.0.0.0', download: 'today'},
        ]
    }), 1000));
};

const updateServices = async (services: IInstallServices): Promise<void> => {
    return console.log(services);
};

const requestDownloadService = async (): Promise<void> => {
    return console.log("Request send");
};


export const fakeUpdateService: IUpdateService = {
    getServices,
    requestDownloadService,
    updateServices,
};